if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('.localization-form__select');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        this.input = this.querySelector('input[name="country_code"], input[name="locale_code"]');
        this.links = this.querySelectorAll('a[data-value]');
        this.overlay = this.querySelector('.country-selector__overlay');
        this.closeBtn = this.querySelector('.country-selector__close-button');

        // ボタンが存在しない場合は中止（他のformにも影響しないように）
        if (!this.button || !this.panel) return;

        // ▼ ドロップダウン開閉
        this.button.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle();
        });

        // ▼ リンククリック時の処理
        this.links.forEach((link) => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            this.select(link.dataset.value);
          });
        });

        // ▼ 外クリックで閉じる
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });

        // ▼ オーバーレイクリックで閉じる
        if (this.overlay) {
          this.overlay.addEventListener('click', () => this.close());
        }

        // ▼ 閉じるボタン対応（モバイル）
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.close());
        }
      }

      toggle() {
        const isHidden = this.panel.hasAttribute('hidden');
        this.panel.toggleAttribute('hidden', !isHidden);
        this.button.setAttribute('aria-expanded', isHidden);
        document.body.classList.toggle('overflow-hidden-mobile', isHidden);
      }

      close() {
        this.panel.setAttribute('hidden', true);
        this.button.setAttribute('aria-expanded', false);
        document.body.classList.remove('overflow-hidden-mobile');
      }

      select(value) {
        const form = this.querySelector('form');
        if (this.input && value) this.input.value = value;
        if (form) form.submit();
      }
    }
  );
}
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        // ▼ セレクター再定義（より柔軟に取得）
        this.button = this.querySelector('.localization-form__select, .disclosure__button');
        this.panel = this.querySelector('.disclosure__list-wrapper, .country-selector');
        this.input = this.querySelector('input[name="country_code"], input[name="locale_code"]');
        this.links = this.querySelectorAll('a[data-value]');
        this.overlay = document.querySelector('.country-selector__overlay');
        this.closeBtn = this.querySelector('.country-selector__close-button');

        // デバッグ確認（読み込みOKかチェック）
        console.log('[localization-form] initialized:', !!this.button, !!this.panel);

        if (!this.button || !this.panel) return;

        // ▼ クリックイベントを直接強制的にセット
        this.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle();
        });

        // ▼ 国リストクリック
        this.links.forEach((link) => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            this.select(link.dataset.value);
          });
        });

        // ▼ 外クリック
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });

        // ▼ オーバーレイクリック
        if (this.overlay) {
          this.overlay.addEventListener('click', () => this.close());
        }

        // ▼ 閉じるボタン
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => this.close());
        }
      }

      toggle() {
        const isHidden = this.panel.hasAttribute('hidden');
        this.panel.toggleAttribute('hidden', !isHidden);
        this.button.setAttribute('aria-expanded', isHidden);
        document.body.classList.toggle('overflow-hidden-mobile', isHidden);
        console.log('[localization-form] toggled:', isHidden ? 'open' : 'close');
      }

      close() {
        this.panel.setAttribute('hidden', true);
        this.button.setAttribute('aria-expanded', false);
        document.body.classList.remove('overflow-hidden-mobile');
      }

      select(value) {
        const form = this.querySelector('form');
        if (this.input && value) this.input.value = value;
        if (form) form.submit();
      }
    }
  );
}
